// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__2_Rsh","logo":"Logo_logo__3Vu_a","placeholderShimmer":"Logo_placeholderShimmer__HB214"};